import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import clsx from 'clsx';
import { textColor } from '../styles/styles';

const GlobalSearchForm = ({ tr, className, onSubmitted }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const currentQuery = location.pathname === '/search' ? searchParams.get('q') || '' : '';
    const [value, setValue] = useState(currentQuery);

    useEffect(() => {
        setValue(currentQuery);
    }, [currentQuery]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const query = value.trim();
        navigate(query ? `/search?q=${encodeURIComponent(query)}` : '/search');
        if (onSubmitted) {
            onSubmitted();
        }
    };

    return (
        <form onSubmit={handleSubmit} className={clsx('flex items-center w-full', className)}>
            <div className="relative w-full">
                <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                    </svg>
                </div>
                <input
                    type="search"
                    name="q"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    className={clsx(
                        'bg-gray-50 dark:bg-gray-700/50 pl-10 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 text-sm rounded-lg p-2.5 w-full focus:outline-none focus:ring-0 focus:border-[#41A6D7]',
                        textColor
                    )}
                    placeholder={tr('search')}
                    aria-label={tr('search')}
                />
            </div>
        </form>
    );
};

export default GlobalSearchForm;
